/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row1_ChatgptInputs */

const en_mk_cmp_row1_chatgpt = /** @type {(inputs: Mk_Cmp_Row1_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat only, doesn't attach to a task`)
};

const id_mk_cmp_row1_chatgpt = /** @type {(inputs: Mk_Cmp_Row1_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrolan saja, tak menempel ke tugas`)
};

/**
* | output |
* | --- |
* | "Chat only, doesn't attach to a task" |
*
* @param {Mk_Cmp_Row1_ChatgptInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row1_chatgpt = /** @type {((inputs?: Mk_Cmp_Row1_ChatgptInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row1_ChatgptInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row1_chatgpt(inputs)
	return en_mk_cmp_row1_chatgpt(inputs)
});